<template>
  <div class="company">
    <SiteHeader/>
    <div class="company__hero">
      <div class="container">
        <h1>Our Company</h1>
        <h5>PortlandPatent.com is based in Portland, Oregon and offers the services of local Attorneys at Law and Registered U.S. Patent Attorneys Spencer K. Hunter, who specializes in Patent and Intellectual Property Law in Portland and surrounding areas.</h5>
      </div>
    </div>
    <div class="company__main">
      <div class="container">
        <div class="bios">
          <div class="bios__bio">
            <h2>Attorney At Law: Spencer K. Hunter</h2>
            <img src="https://19ugtf3snp8x3c6o8y2mfb40-wpengine.netdna-ssl.com/wp-content/uploads/2017/10/Spencer-e1507231605431.jpg" alt="Spencer K. Hunter"/>
            <p>Spencer is a licensed attorney at law admitted to practice before the Oregon State Bar (OSB); a licensed Patent Attorney admitted to practice before the United States Patent and Trademark Office (USPTO); a certified Program Manager (Prince2); and a certified ISO 9001:2000 Manufacturing Lead Auditor (RABQSA).</p>
            <p>As a former software engineer for Silicon Valley companies, Spencer understands the language and needs of your developers. Whether discussing cloud computing, data communications, databases, or data processing, Spencer can quickly engage with your technical experts and tackle the difficult challenge of presenting software based technologies to the United States Patent and Trademark Office.</p>
            <p>As a former program manager and ISO 9000 compliance auditor, Spencer understands how to manage complex projects, assets, and portfolios. Before entering the practice of law, Spencer was responsible for maintaining the ISO compliance and certification at a high-tech manufacturing company’s U.S. operations having revenues in excess of $10-billion. Whether your company is large or small, Spencer can streamline the logistics and management of your patent portfolio so that you can focus on your core business objectives.</p>
          </div>
          <div class="bios__bio">
            <h2>About</h2>
            <p>Based out of downtown Portland, Oregon, PortlandPatent.com provides streamlined patent preparation services through the use of our custom-developed digital platform. This platform allows us to extend our traditional in-person based law practice to a greater number of inventors at a reduced cost, while still providing one-on-one consultation services (such as in-person or video calls with every provisional patent application) as well as the personal and dedicated attention that each patent application requires.</p>
            <p>PortlandPatent.com’s founder Spencer K. Hunter, is licensed before the Oregon State Bar to practice law in Oregon and is also a federally registered patent attorney, licensed to practice intellectual property law nationwide before the U.S. Patent and Trademark Office.</p>
            <p>Spencer practices with the law firm of <a href="https://eoplaw.com" target="_blank">Elliott, Ostrander &amp; Preston, P.C.</a>, which has been in practice for more than 25 years, providing legal representation to, and primarily focused on, business and corporate guidance. The firm’s patent attorneys bring over 40 years of collective intellectual property law experience. At Elliott, Ostrander &amp; Preston, Spencer focuses on the preparation and prosecution of complex software and communications related patent applications, as well as mechanical and medical-related patent applications, in addition to trademarks and copyrights. </p>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader'
import Footer from '@/components/Footer'

export default {
  name: 'Company',
  components: {
    SiteHeader,
    Footer
  }
}
</script>

<style scoped lang="scss">
.company {
  .container {
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
  }
  &__hero {
    background: linear-gradient(152deg, #4687c5, #37a7c0);
    .container {
      margin: 0 auto;
      max-width: 700px;
      padding: 80px 40px 100px 40px;
      text-align: center;

      h1 {
        color: white;
        font-family: Raleway, sans-serif;
        font-weight: 300;
        margin-bottom: 40px;
        line-height: 1.3;
        strong {
          font-weight: 700;
        }
      }

      h5 {
        color: white;
        font-size: 18px;
      }

      p {
        color: white;
        font-family: Raleway, sans-serif;
        font-weight: 500;
      }
    }
  }
  &__main {
    padding: 80px 40px;
  }
  .bios {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 40px;
    &__bio {
      background: white;
      padding: 40px;
      margin: 40px 0;
      img {
        float: right;
        padding: 0 0 20px 20px;
        width: 150px;
      }
    }
  }
}
</style>